import { captureError } from "src/utils/errorReporting";

// Guard React's commit-phase DOM calls against external DOM mutation by
// browser page translators — Google Translate on Chrome/iOS wraps React-managed
// text nodes in <font> tags, so React's next re-render calls insertBefore /
// removeChild with nodes the translator has moved and WebKit throws
// "NotFoundError: The object can not be found here.", crashing the /tilaa
// wizard mid-order (BETONIJERRY-16 → cascading stack-overflow BETONIJERRY-17).
// Standard workaround from https://github.com/facebook/react/issues/11538 —
// degrade the mismatched call to a no-op instead of throwing, and report once
// per session so we keep Sentry visibility without spamming. Translation stays
// usable for non-Finnish-speaking customers (blocking it via translate="no"
// would hurt exactly the users who need the wizard translated).
//
// Reported at level "info", not "error": the guard firing means it WORKED —
// external interference was absorbed and the wizard survived. It confirmed
// itself in prod as BETONIJERRY-1B (Chrome, en-GB locale, /tilaa). Keep it as
// telemetry so a volume spike still shows a non-translator cause; don't let it
// page anyone as a defect. The Error wrapper is kept for the stack trace, which
// is what tells us the mutation came from React's commit phase.
let reported = false;
const reportOnce = (method) => {
    if (reported) return;
    reported = true;
    captureError(new Error(`DOM mutated outside React (page translator?) — ${method} guarded`), {
        tags: { domPatch: "translate-guard" },
        level: "info",
    });
};

export function installDomPatches() {
    if (typeof Node !== "function" || !Node.prototype) return;

    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
        if (child && child.parentNode !== this) {
            reportOnce("removeChild");
            return child;
        }
        return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            reportOnce("insertBefore");
            return newNode;
        }
        return originalInsertBefore.apply(this, arguments);
    };
}
